import { useEffect } from "react";
import { Text } from '@aws-amplify/ui-react';
// import { CheckboxField } from '@aws-amplify/ui-react';
// import { Link } from 'react-router-dom';
import { Flex } from "@aws-amplify/ui-react";

import { Authenticator, useAuthenticator, View } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
// import { SelectField } from '@aws-amplify/ui-react';
import {
  Button,
  Heading,
  ThemeProvider,
  useTheme,
} from '@aws-amplify/ui-react';

import { useNavigate, useLocation } from 'react-router';
import './Login.css'

export function LoginDistributor() {

  const { tokens } = useTheme();
  
  const theme = {
    name: 'Auth Theme',
    tokens: {
      colors: {
        background: {
          primary: {
            value: tokens.colors.white,
          },
          secondary: {
            value: tokens.colors.black,
          },
        },
        font: {
          interactive: {
            value: tokens.colors.white.value,
          },
        },
        brand: {
          primary: {
            '10': tokens.colors.teal['100'],
            '80': tokens.colors.teal['40'],
            '90': tokens.colors.teal['20'],
            '100': tokens.colors.teal['10'],
          },
        },
      },
      components: {
        tabs: {
          item: {
            color: {
              value: tokens.colors.white.value,
            },
            _focus: {
              color: {
                value: tokens.colors.black.value,
              },
            },
            _hover: {
              color: {
                value: tokens.colors.white.value,
              },
            },
            _active: {
              color: {
                value: tokens.colors.black.value,
              },
            },
          },
        },
      },
    },
  };

  const { route } = useAuthenticator((context) => [context.route]);
  const location = useLocation();
  const navigate = useNavigate();

  let from = location.state?.from?.pathname || '/home/distributor';
  useEffect(() => {
    if (route === 'authenticated') {
      console.log(from)
      navigate(from, { replace: true });
    }
  }, [route, navigate, from]);

  const components = {
    Header() {
      const { tokens } = useTheme();
      return (
        <View textAlign="center" padding={tokens.space.large}>
          {/* <Image
            alt="Merum logo"
            src={logo}
          /> */}
        </View>
      );
    },
    Footer() {
      const { tokens } = useTheme();
    
      const handleGoBack = () => {
        window.location.href = '/'; // Redirect to the home page
      };
    
      return (
        <>
          <Flex justifyContent="center" marginTop="20px">
            <Button
              variation="primary"
              onClick={() => handleGoBack("initial")}
              style={{
                height: "45px",
                padding: "10px 20px",
              }}
            >
              Home
            </Button>
          </Flex>
    
          {/* Footer Text */}
          <View textAlign="center" padding={tokens.space.large}>
            <Text color={tokens.colors.neutral[80]}>
              &copy; {new Date().getUTCFullYear()} Merum. All rights reserved.
            </Text>
          </View>
        </>
      );
    },
    SignIn: {
      Header() {
        const { tokens } = useTheme();
  
        return (
          <Heading
            padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
            level={4}
          >
            Sign in to your account as a Distributor
          </Heading>
        );
      },
      Footer() {
        // const { toResetPassword } = useAuthenticator();
  
        return (
          <View textAlign="center">
            {/* <Button
              fontWeight="normal"
              onClick={toResetPassword}
              size="small"
              variation="link"
            >
              Reset Password
            </Button> */}
          </View>
        );
      },
    },
    SignUp: {
      Header() {
        const { tokens } = useTheme();
        return (
          <Heading
            padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
            level={4}
          >
            Create a new account
          </Heading>
        );
      },
      FormFields() {
        // const { validationErrors } = useAuthenticator();
        return (
          <>
            {/* Re-use default `Authenticator.SignUp.FormFields` */}
            <Authenticator.SignUp.FormFields />
            {/* <SelectField
                label = "Testing"
                isRequired
                >
                <option value="FR">FR</option>
                <option value="EN">EN</option>
                <option value="IT">IT</option>
            </SelectField> */}
            {/* Append & require Terms & Conditions field to sign up  */}
            {/* <CheckboxField
              errorMessage={validationErrors.acknowledgement}
              hasError={!!validationErrors.acknowledgement}
              name="acknowledgement"
              value="yes"
              label={<label>I agree to <Link target="_blank" to='/terms-and-condition'>Privacy Policy and Terms of Service</Link></label>}
            /> */}
          </>
        );
      },
      Footer() {
        const { toSignIn } = useAuthenticator();
        return (
          <View textAlign="center">
            <Button
              fontWeight="normal"
              onClick={toSignIn}
              size="small"
              variation="link"
            >
              Back to Sign In
            </Button>
          </View>
        );
      },
    },
    ConfirmSignUp: {
      // Header() {
      //   const { tokens } = useTheme();
      //   return (
      //     <Heading
      //       padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
      //       level={4}
      //     >
      //     Inserisci le Informazioni:
      //     </Heading>
      //   );
      // },
      // Footer() {
      //   return <Text>Footer Information</Text>;
      // },
    },
    SetupTOTP: {
      Header() {
        // const { tokens } = useTheme();
        // return (
        //   <Heading
        //     padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
        //     level={3}
        //   >
        //     Inserisci le Informazioni:
        //   </Heading>
        // );
      },
      Footer() {
        // return <Text>Footer Information</Text>;
      },
    },
    ConfirmSignIn: {
      Header() {
        // const { tokens } = useTheme();
        // return (
        //   <Heading
        //     padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
        //     level={3}
        //   >
        //     Inserisci le Informazioni:
        //   </Heading>
        // );
      },
      Footer() {
        // return <Text>Footer Information</Text>;
      },
    },
    ResetPassword: {
      Header() {
        // const { tokens } = useTheme();
        // return (
        //   <Heading
        //     padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
        //     level={3}
        //   >
        //     Inserisci le Informazioni:
        //   </Heading>
        // );
      },
      Footer() {
        // return <Text>Footer Information</Text>;
      },
    },
    ConfirmResetPassword: {
      Header() {
        return (
          <>
          <Heading
            //padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
            level={3}
          >
            We have sent you an email
          </Heading>
          <p class="amplify-text amplify-authenticator__subtitle">Your code is on its way. To log in, enter the code we sent you via email. It may take a minute to arrive.</p>
          </>
        );
      },
      Footer() {
        // return <Text>Footer Information</Text>;
      },
    },
  };
  
  const formFields = {
    signIn: {
    },
    signUp: {
      "custom:d_code": {
        label: 'Distributor Permit License Number:',
        placeholder: 'Format: XX-I-XXXXX (e.g., AK-I-15000)',
        isRequired: false,
        order: 1,
      },
      "custom:d_contact_name": {
        label: 'Contact Name:',
        placeholder: 'Contact Name',
        isRequired: false,
        order: 2,
      },
      "custom:d_contact_phone": {
        label: 'Contact Phone:',
        placeholder: 'Contact Phone',
        isRequired: false,
        order: 3,
      },
      "custom:user_type": {
        type: 'hidden',
        value: 'distributor',
      },
      password: {
        label: 'Password:',
        placeholder: 'Enter Your Password',
        isRequired: true,
        order: 4,
      },
      confirm_password: {
        label: 'Confirm your Password:',
        placeholder: 'Confirm your Password',
        order: 5,
      },
    },
    forceNewPassword: {
      password: {
        placeholder: 'Enter Your Password',
      },
    },
    resetPassword: {
      // email: {
      //   placeholder: 'Enter your email:',
      // },
    },
    confirmResetPassword: {
      confirmation_code: {
        placeholder: 'Enter your Confirmation Code:',
        label: 'Confirmation Code',
        isRequired: false,
      },
      confirm_password: {
        placeholder: 'Enter Your Password',
      },
    },
    setupTOTP: {
      QR: {
        totpIssuer: 'test issuer',
        totpUsername: 'amplify_qr_test_user',
      },
      confirmation_code: {
        label: 'Confirmation Code',
        placeholder: 'Enter your Confirmation Code:',
        isRequired: false,
      },
    },
    confirmSignIn: {
      confirmation_code: {
        label: 'Confirmation Code',
        placeholder: 'Enter your Confirmation Code:',
        isRequired: false,
      },
    },
  };

  return (
    <View
      className="auth-wrapper"
      style={{ zoom: 0.8, paddingTop: '5%' }}
    >
      <div>
      <ThemeProvider theme={theme}>
        <Authenticator id="d"
            loginMechanisms={['email']}
            // socialProviders={['google']}
            // variation="modal"
            formFields={formFields}
            components={components}
            // services={{
            //   async validateCustomSignUp(formData) {
            //     if (!formData.acknowledgement) {
            //       return {
            //         acknowledgement: 'You must accept the Terms and Conditions',
            //       };
            //     }
            //   },
            // }}
        >
        </Authenticator>
        
      </ThemeProvider>
      </div>
    </View>
  );
}